// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__pQ8n7","content":"styles_content__xLRhw","selectAll":"styles_selectAll__11lhX"};